<template>
  <order-list :is-order-status="50"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'RequestRefund',
  components: {
    OrderList
  }
}
</script>
